module.exports = __webpack_public_path__ + "static/media/pin_multi.030b980a.svg";